export const HORIZONTAL_BARCHART_MAXWIDTH = 150;
